export interface ChatAccessContext {
  generalChatEnabled: boolean;
  canChatInGeneral: boolean;
  privateChatEnabled: boolean;
  canChatInPrivate: boolean;
  privateGroupChatEnabled: boolean;
  privateGroupChatRoles: string[];
  localUserRole: string;
  isBreakoutRoom: boolean;
  isSystemSession: boolean;
}

export interface ChatAccess {
  chatAvailable: boolean;
  publicChatAvailable: boolean;
  privateChatAvailable: boolean;
  privateGroupChatAvailable: boolean;
}

// A system session has no identity of its own, so its visibility comes from room configuration:
// public chat is the shared record and is shown; private chats are confidential and never are.
export const canAccessChat = (ctx: ChatAccessContext): ChatAccess => {
  const publicChatAvailable =
    ctx.generalChatEnabled && (ctx.canChatInGeneral || ctx.isSystemSession);
  const privateChatAvailable =
    !ctx.isSystemSession && ctx.privateChatEnabled && ctx.canChatInPrivate;
  const privateGroupChatAvailable =
    !ctx.isSystemSession &&
    ctx.privateGroupChatEnabled &&
    ctx.privateGroupChatRoles.includes(ctx.localUserRole);

  const chatAvailable = ctx.isBreakoutRoom
    ? publicChatAvailable
    : publicChatAvailable || privateChatAvailable || privateGroupChatAvailable;

  return { chatAvailable, publicChatAvailable, privateChatAvailable, privateGroupChatAvailable };
};
